// extracted by mini-css-extract-plugin
export default {"icon":"HistoryButton_icon__Kef63"};